/**
 * Copyright IBM Corp. 2022, 2026
 */

import { DateTime } from 'luxon'
import strftime from 'strftime'

export function filterForUpcomingEventsByUsersCurrentDate(events) {
	return events.filter((ev) => eventIsTodayOrFutureForUser(ev.startTime))
}

export function filterForPastEventsByUsersCurrentDate(events) {
	return events.filter((ev) => !eventIsTodayOrFutureForUser(ev.startTime))
}

function eventIsTodayOrFutureForUser(startTime) {
	// // Today's date with 0 hours, 0 minutes, 0 seconds..
	const currentDate = new Date(new Date().setHours(0, 0, 0, 0)) // => Tue Sep 08 2020 00:00:00 GMT-0400 (Eastern Daylight Time)
	// The event's localized time..
	const startDateOnly = new Date(startTime) // => Tue Sep 08 2020 16:00:00 GMT-0400 (Eastern Daylight Time)
	return currentDate < startDateOnly
}

export function convertTimeToLocalOffset(isoString) {
	return DateTime.fromISO(isoString).toLocaleString({
		hour: '2-digit',
		minute: '2-digit',
		timeZoneName: 'short',
	})
}

export function convertTimeToShortDate(isoString) {
	return DateTime.fromISO(isoString).toLocaleString({
		month: 'long',
		day: '2-digit',
	})
}

export function differenceInMinutes(endTimeIso, startTimeIso) {
	return DateTime.fromISO(endTimeIso)
		.diff(DateTime.fromISO(startTimeIso), 'minutes')
		.toFormat('m')
}

export const humanDate = (dateVal) => {
	const stamp = new Date(dateVal)
	return {
		date: strftime('%b %d %Y', stamp),
		dateString: strftime('%Y-%m-%d', stamp),
		dateWithTime: strftime('%b %d %Y %I:%M %p', stamp),
		time: strftime('%I:%M %p', stamp),
		month: strftime(`%B`, stamp),
		year: strftime('%Y', stamp),
	}
}

export function formatEventsClientSide(events) {
	return events.map((e) => ({
		...e,
		startDateHelpers: humanDate(e.startTime), // Used in various places downstream
	}))
}
